import { PaymentRequestServiceType } from 'mvppoker-portal-common/api'
import React, { useMemo } from 'react'
import { FormProvider, RegisterOptions, useForm } from 'react-hook-form'
import MathUtils from 'mvppoker-portal-common/utils/MathUtils'
import { MVPButton } from '../../Buttons/MVPButton'
import { MVPTextInput } from '../../TextInput/MVPTextInput'
import { Pattern } from '../../../utils/Regex'
import './WalletAddFundsWithProviderModal.scss'

export type WalletAddFundsWithProviderModalViewFormData = {
	amount: string
}
export interface WalletAddFundsWithProviderModalViewProps
{
	service: PaymentRequestServiceType
	isLoading: boolean
	clickSubmit: (amount: string) => void
}

export const WalletAddFundsWithProviderModalView : React.FC<WalletAddFundsWithProviderModalViewProps> = ({ service, isLoading, clickSubmit }) =>
{
	const form = useForm<WalletAddFundsWithProviderModalViewFormData>()

	const prompt = useMemo(() => {
		return `${service} is an external service,  after clicking DEPOSIT FUNDS you will be taken to ${service}'s secure website to choose your payment method.`
	}, [service])

	const charge = useMemo(() => {
		return `Using ${service} incurrs an extra 10% charge fee which will be deducted from your funds to be added.`
	}, [service])

	const formAmountValidation: RegisterOptions = {
		required: { value: true, message: 'Please insert an amount' },
		validate: {
			isNumber: (value: string) => Pattern.Decimal.test(value) || 'Must be a number',
			min: (value: string) => MathUtils.IsGreaterThanOrEqualTo(value, '50.0') || 'Minimum amount is 50.00',
			max: (value: string) => MathUtils.IsLessThan(value, '10000.0') || 'Maximum amount is 10000.00',
		},
	}

	return (
		<>
			<span className='modal-title'>{service}</span>
			<FormProvider {...form}>
				<form onSubmit={form.handleSubmit((data) => clickSubmit(data.amount))}>
					<MVPTextInput 
						formField='amount' 
						label='Amount' 
						placeholder='Amount to Deposit' 
						formValidation={formAmountValidation} 
						prefix='$'
					/>
					<MVPButton type='submit' loading={isLoading}>
						Add Funds
					</MVPButton>
				</form>
			</FormProvider>
			<span className='modal-text'>{prompt}</span>
			<span className='modal-text-small'>{charge}</span>
		</>
	)
}